import { render } from "./garbage_processing_center.vue?vue&type=template&id=64bc6b7b&scoped=true"
import script from "./garbage_processing_center.vue?vue&type=script&lang=js"
export * from "./garbage_processing_center.vue?vue&type=script&lang=js"

import "./garbage_processing_center.vue?vue&type=style&index=0&id=64bc6b7b&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\MAHASBM\\MAHASBM-CODE\\ui-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64bc6b7b"]])

export default __exports__